import React from 'react';
import { StepDetails } from '../../pages/Registration';

interface StepProgressBarProps {
    currentStepIndex: number;
    steps: StepDetails[]; // Supponendo che ogni step abbia almeno un titolo.
}

const StepProgressBar: React.FC<StepProgressBarProps> = ({ currentStepIndex, steps }) => {
    return (
        <div className="w-full bg-white rounded-lg p-3 sm:p-4 shadow-lg">
            <div className="flex items-center gap-1 sm:gap-2">
                {steps.map((_, index) => (
                    <React.Fragment key={index}>
                        <div className="flex flex-col items-center">
                            <div className={`
                                w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center transition-all duration-300
                                ${index <= currentStepIndex 
                                    ? 'bg-fpcred text-white shadow-lg' 
                                    : 'bg-gray-200 text-gray-500'
                                }
                                ${index === currentStepIndex ? 'ring-2 ring-fpcpink scale-110' : ''}
                            `}>
                                {index < currentStepIndex ? (
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                ) : (
                                    <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-current rounded-full"></div>
                                )}
                            </div>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={`
                                flex-1 h-0.5 sm:h-1 mx-1 sm:mx-2 rounded-full transition-all duration-300
                                ${index < currentStepIndex ? 'bg-fpcred' : 'bg-gray-200'}
                            `} />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default StepProgressBar;